import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import { FormControl, TextField } from '@material-ui/core';
import { post } from '../../Services/http';
import LoadingDots from '../LoadingDots';
import Icon from '../IconBase/Icon';

const LoginModalForgotPasswordForm = ({
  prefilledEmail,
  lostPasswordOverlayText,
  onError,
  onBackClick,
}) => {
  const [email, setEmail] = useState(prefilledEmail ?? '');
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const sendForgotPassword = () => {
    setIsLoading(true);
    post('/api/login/forgotpassword', { email })
      .then((res) => res.json())
      .then((data) => {
        onError(data.error);

        if (data.success) {
          setShowSuccess(true);
        }
      })
      .catch((err) => err.response.json().then((data) => onError(data.error)))
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <h3 style={{ display: 'flex', alignItems: 'center' }} cursor="pointer">
        <Icon iconCode="chevron_left" /> {translate('login.forgot-password')}
      </h3>
      {lostPasswordOverlayText && (
        <p className="login-modal__lost-password-text">
          {lostPasswordOverlayText}
        </p>
      )}
      {!showSuccess && (
        <>
          <FormControl disabled={isLoading}>
            <label htmlFor="email">{translate('general.email')}</label>
            <TextField
              variant="outlined"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={translate('general.enter-email')}
            />
          </FormControl>
          <div className="login-modal__buttons">
            <button
              className="btn btn--black"
              onClick={sendForgotPassword}
              disabled={!email || email == ''}
            >
              {!isLoading && translate('general.send')}
              {isLoading && <LoadingDots size="small" color="white" />}
            </button>
          </div>
          <a
            onClick={() => !isLoading && onBackClick()}
            className="login-modal__back-to-login-link"
          >
            {translate('general.back-to-login')}
          </a>
        </>
      )}
      {showSuccess && (
        <>
          <p>{translate('login.forgot-password.success')}</p>
          <button className="btn btn--outline" onClick={onBackClick}>
            {translate('general.back')}
          </button>
        </>
      )}
    </>
  );
};

export default LoginModalForgotPasswordForm;
